import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'listBreakpointSort',
})
export class ListBreakpointSortPipe implements PipeTransform {
    public transform<T>(value: T[] | undefined, isMobile: boolean): T[] {
        if (!Array.isArray(value)) {
            return [];
        }

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (value.length <= 2 || isMobile) {
            return value;
        }

        const result: T[] = [];
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        const firstHalf: T[] = value.slice(0, Math.ceil(value.length / 2));
        const secondHalf: T[] = value.slice(firstHalf.length);

        for (let i = 0; i < firstHalf.length; i += 1) {
            result.push(firstHalf[i]);

            // eslint-disable-next-line sonarjs/different-types-comparison
            if (secondHalf[i] !== undefined) {
                result.push(secondHalf[i]);
            }
        }

        return result;
    }
}
